var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 244.726,
    height: 34.825,
    viewBox: "0 0 244.726 34.825",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25856",
    "data-name": "Group 25856",
    transform: "translate(-302.11 -233.369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(302.11 233.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M323.868,457.759h-8.439v29.027H310.5V457.759H302.11V452.88h21.758Z",
    transform: "translate(-302.11 -452.519)",
    fill: "#2e2545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M420.43,479.1q0,7.676-8.133,7.677h-7.472q-3.914,0-5.846-1.677a7.452,7.452,0,0,1-2.339-5.948V460.6a7.722,7.722,0,0,1,2.391-6q1.881-1.729,5.795-1.729h7.524q8.081,0,8.084,7.726v18.5Zm-4.83-1.186V461.989a4.37,4.37,0,0,0-1.022-3.267,4.8,4.8,0,0,0-3.369-.97h-5.2a4.964,4.964,0,0,0-3.418.945,4.359,4.359,0,0,0-1.019,3.292v15.775a4.35,4.35,0,0,0,1.123,3.216,4.649,4.649,0,0,0,3.317.918h5.2a5.1,5.1,0,0,0,3.341-.893,3.891,3.891,0,0,0,1.046-3.09Z",
    transform: "translate(-370.814 -452.512)",
    fill: "#2e2545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M527.924,459.531a6.3,6.3,0,0,0-2.237-4.983,8.039,8.039,0,0,0-5.286-1.677H503.623v4.885h4.931l10.524,0q3.967,0,3.964,3.42v4.035q0,3.832-4.068,3.83H503.62v17.744h4.931V474.073h12.1a7.3,7.3,0,0,0,5.363-1.932,7.166,7.166,0,0,0,1.956-5.338q0-3.864-.052-7.27Z",
    transform: "translate(-448.568 -452.512)",
    fill: "#2e2545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M626.618,457.759h-8.439v29.027h-4.931V457.759H604.86V452.88h21.758Z",
    transform: "translate(-522.149 -452.519)",
    fill: "#2e2545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M700.411,506.1H695.48v12.149a6.708,6.708,0,0,0,2.238,5.439,8.367,8.367,0,0,0,5.693,1.779h14.081v-4.879H704.731q-4.323,0-4.322-3.885v-5.723h17.08V506.1h-17.08Z",
    transform: "translate(-588.012 -491.2)",
    fill: "#d42b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M703.861,452.88a7.369,7.369,0,0,0-5.491,2.008,6.573,6.573,0,0,0-1.639,2.863h10.45v.008H718.4V452.88h-14.54Z",
    transform: "translate(-588.92 -452.519)",
    fill: "#d42b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M942.681,485.827h-4.729V458.934l-8.693,23.943q-1.27,3.508-3.56,3.508a2.744,2.744,0,0,1-2.237-1.068,8.258,8.258,0,0,1-1.117-2.287l-8.9-24.1v26.894H908.72v-29.74a4.741,4.741,0,0,1,1.117-3.254,3.915,3.915,0,0,1,3.1-1.27q3,0,4.117,3.2l8.592,24.2,8.745-24.205q1.168-3.2,4.068-3.2a3.829,3.829,0,0,1,3.125,1.32,5.151,5.151,0,0,1,1.093,3.4v29.544Z",
    transform: "translate(-742.995 -451.56)",
    fill: "#2e2545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M1084.2,486.787h-4.931V457.759h-6.049V452.88h10.98v33.909Z",
    transform: "translate(-862.553 -452.519)",
    fill: "#2e2545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M1168.68,486.787h-4.931V457.759H1157.7V452.88h10.98v33.909Z",
    transform: "translate(-923.954 -452.519)",
    fill: "#2e2545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M789.813,485.973l11.234-31.117q1.119-3.1,3.508-3.1c1.593,0,2.814,1.033,3.56,3.1l11.234,31.117h-5.237l-9.507-27.35L795,485.973H789.81Z",
    transform: "translate(-656.571 -451.705)",
    fill: "#d42b71"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.0ab960e2bf7e14447c92951cd765dbe3.svg";
export { ForwardRef as ReactComponent };